<template>
  <div
    id="cup_scheduleDetail_lineup"
    v-show="currThemeObj"
    :style="{
      '--mixtmt_lineup_footBallPlaygroundColor':
        currThemeObj.cssStyle.lineup_footBallPlaygroundColor,
      '--mixtmt_homePlayerNo_bg': `url('/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/homePlayerNo_bg.png')`,
      '--mixtmt_awayPlayerNo_bg': `url('/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/awayPlayerNo_bg.png')`,
    }"
  >
    <div class="themeOperation_area">
      <span class="themeType_changeArea">
        <span
          class="themeType_item"
          v-for="item in themeTypeArr"
          :key="item.id"
          :class="item.act ? 'act' : ''"
          v-text="item.name"
          @click="changeThemeType(item)"
        ></span>
      </span>
    </div>
    <template v-if="currThemeType && currThemeType.id === 'high'">
      <Complex_doubleTeam
        v-if="complexDoubleTeam_themeItem"
        :datas="complexDoubleTeam_themeItem.renderData"
        :themeItem_titleList="complexDoubleTeam_titleList"
        :isScore="complexDoubleTeam_isScore"
        :detailPathName="`${complexDoubleTeam_detailPathName}_${currThemeObj.moduleRouteNameEn}`"
      >
        <template v-slot:selectOpt>
          <span class="section_main">
            <SelectItem
              v-for="selectItem in selectList"
              :key="selectItem.state"
              :options="selectItem"
              :curVal="selectItem.curVal"
              themeClass="whiteBg compelx_doubleTeam"
              @changeValEvent="selectChangeVal"
            ></SelectItem>
          </span>
        </template>
        <template v-slot:sharingMenu>
          <MultipleChoiceSharingMenuRow
            :list="MultipleChoiceSharingMenuRow_list"
            @clickMenuEvent="MultipleChoiceSharingMenuRow_clickMenuHandler"
            @clickPublicThemeEvent="
              MultipleChoiceSharingMenuRow_clickPublicThemeHandler
            "
          ></MultipleChoiceSharingMenuRow>
        </template>
      </Complex_doubleTeam>
    </template>
    <template v-else>
      <div class="commonThemeList">
        <div
          class="themeItem_container"
          v-for="item in commonThemeList"
          :key="item.analysisItemId"
        >
          <selectThemeContainer
            :currThemeObj="currThemeObj"
            :themeItem="item"
            @changeSelectToThemeItemEvent="changeSelectToThemeItem"
          ></selectThemeContainer>
        </div>
        <!-- <div :style="{width: '100%'}">
          <Lineup_singleTeam></Lineup_singleTeam>
        </div> -->
      </div>
    </template>
  </div>
</template>

<script>
import {
  https_package_findAnalysisItem,
  https_package_getMoreDataByAnalysisID,
} from '@api/platfrom_base_api'
import cup_base_data_mixin from '@mixins/cup_base_data'
import platfrom_refresh_data_mixin from '@mixins/platfrom_refresh_data'
import Complex_doubleTeam from '@components/football/html/HTML_LINEUP/complex_doubleTeam.vue'
import MultipleChoiceSharingMenuRow from '@components/base/theme/multipleChoiceSharingMenuRow.vue'
import selectThemeContainer from '@components/platfromBase/compreSportsMeet/selectThemeContainer.vue'
import SelectItem from '@components/platfromBase/basketball/selectItem.vue'
export default {
  name: 'cup_scheduleDetail_lineup',
  mixins: [cup_base_data_mixin, platfrom_refresh_data_mixin],
  components: {
    MultipleChoiceSharingMenuRow,
    Complex_doubleTeam,
    selectThemeContainer,
    SelectItem,
  },
  props: {
    matchInfor: {
      type: Object,
      default: () => ({
        matchStatus: '',
        homeId: '',
        homeName: '',
        homeScore: '',
        homeLogo: '',
        awayId: '',
        awayName: '',
        awayScore: '',
        awayLogo: '',
        venueId: '',
        venueName: '',
      }),
    },
  },
  data() {
    return {
      lineupType: '',
      commonThemeList: null,
      selectList: [
        {
          list: [],
          keyValArr: ['value', 'name'],
          placeholder: '请选择',
          isFilterable: false,
          widthVw: 9.74,
          curVal: '',
          state: 'sectionType',
        },
      ],
      curSelect_sectionType: '',

      complexDoubleTeam_themeItem: null,
      complexDoubleTeam_titleList: ['首发阵容', ''],
      complexDoubleTeam_detailPathName: 'playerDetailIndex',
      currThemeType: null,
      themeTypeArr: [
        {
          name: '对阵主题',
          id: 'high',
          act: false,
        },
        {
          name: '常规主题',
          id: 'common',
          act: false,
        },
      ],
      dataOrigin: 'opta',
      themeTemplateType: 2,
      renderThemeList: null,
      MultipleChoiceSharingMenuRow_list: [
        {
          id: 'lineup',
          name: '首发阵容',
          isAct: true,
        },
        {
          id: 'score',
          name: '评分',
          isAct: false,
        },
      ],
      subListThemeTitleArr: ['替补名单', '替补阵容(仅含已上场球员)'],

      singleTeam_homeLineup_themeItem: null, //新版 单只球队 主队 首发阵容 横版
      singleTeam_awayLineup_themeItem: null, //新版 单只球队 客队 首发阵容 横版
      doubleTeamCombatLineup_themeItem: null, // 新版 首发阵容【主队+客队】(组装好的，可以直接用)
      doubleTeamSubList_themeItem: null, //新版 替补名单【主队+客队】(组装好的，可以直接用)
      doubleTeamSubLineup_themeItem: null, //新版 替补阵容【主队+客队】(组装好的，可以直接用)
      complexDoubleTeam_isScore: false, //是否展示【评分】主题，比【首发阵容】多球员评分和球队评分
    }
  },
  created() {
    const query = this.$route.query
    if (query.lineupType) {
      this.lineupType = query.lineupType
    }
    this.init()
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      const query = this.$route.query
      this.cid = query.cid
      this.sid = query.sid
      this.mid = query.mid
      this.changeThemeType(this.themeTypeArr[0])
      this.complexDoubleTeam_titleList[1] = this.subListThemeTitleArr[0]
      await this.findAnalysisItem(this.themeTemplateType)

      const sectionList = [
        {
          name: '对阵双方',
          value: 'all',
        },
        {
          name: this.matchInfor.homeName,
          value: this.matchInfor.homeId,
        },
        {
          name: this.matchInfor.awayName,
          value: this.matchInfor.awayId,
        },
      ]
      this._formatSelectHandler(sectionList)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    selectChangeVal(data) {
      console.debug('selectChangeVal:', data)
      if (data.state === 'sectionType') {
        this.curSelect_sectionType = data.val
      }
      console.debug(this.curSelect_sectionType)
      this.formatComplexDoubleTeamHandler(data.val, this.shareType)
    },
    formatComplexDoubleTeamHandler(sectionType, shareType) {
      if (shareType === 'score') {
        // 【评分】
        // 默认 双方评分主题
        let complexDoubleTeam_themeItem = JSON.parse(
          JSON.stringify(this.doubleTeamPlayerScore_themeItem)
        )
        if (sectionType === this.matchInfor.homeId + '') {
          complexDoubleTeam_themeItem = JSON.parse(
            JSON.stringify(this.renderThemeList[5])
          )

          complexDoubleTeam_themeItem.renderData.objectInfo = [
            complexDoubleTeam_themeItem.renderData.objectInfo[0],
          ]
          complexDoubleTeam_themeItem.renderData.data.dataList = [
            complexDoubleTeam_themeItem.renderData.data.dataList[0],
            [],
          ]
        } else if (sectionType === this.matchInfor.awayId + '') {
          complexDoubleTeam_themeItem = JSON.parse(
            JSON.stringify(this.renderThemeList[6])
          )
          complexDoubleTeam_themeItem.renderData.objectInfo = [
            complexDoubleTeam_themeItem.renderData.objectInfo[0],
          ]
          complexDoubleTeam_themeItem.renderData.data.dataList = [
            [],
            complexDoubleTeam_themeItem.renderData.data.dataList[0],
          ]
        }
        this.complexDoubleTeam_themeItem = complexDoubleTeam_themeItem
      } else {
        // 【首发阵容】
        if (sectionType === 'all') {
          this.complexDoubleTeam_themeItem =
            this.computedComplexDoubleTeamThemeItemHandler(
              this.doubleTeamCombatLineup_themeItem,
              this.doubleTeamList_dataList
            )
        } else if (sectionType === this.matchInfor.homeId + '') {
          this.complexDoubleTeam_themeItem =
            this.computedComplexDoubleTeamThemeItemHandler(
              this.singleTeam_homeLineup_themeItem,
              this.doubleTeamList_dataList,
              'home'
            )
        } else if (sectionType === this.matchInfor.awayId + '') {
          this.complexDoubleTeam_themeItem =
            this.computedComplexDoubleTeamThemeItemHandler(
              this.singleTeam_awayLineup_themeItem,
              this.doubleTeamList_dataList,
              'away'
            )
        }
        console.debug(
          'this.complexDoubleTeam_themeItem:',
          this.complexDoubleTeam_themeItem
        )
      }
    },
    _formatSelectHandler(resDataArr, isRefreshFlag) {
      let selectList = this.selectList

      selectList.forEach((svgItem, svgIndex) => {
        svgItem.list = resDataArr.map((item, itemIndex) => {
          const val = item.value + ''
          item.value = val
          if (isRefreshFlag && this[`curSelect_${svgItem.state}`] === val) {
            svgItem.curVal = val
          } else if (!isRefreshFlag) {
            if (itemIndex == 0) {
              svgItem.curVal = val
              this[`curSelect_${svgItem.state}`] = val
            }
          }
          return item
        })
      })
      this.selectList = selectList
    },
    refreshCallback() {
      this.getMoreDataByAnalysisID(this.getMoreDataByAnalysisIDParams)
    },
    changeThemeType(btnItem) {
      this.themeTypeArr.forEach((item, index) => {
        if (item.id === btnItem.id) {
          item.act = true
          this.currThemeType = item
        } else {
          item.act = false
        }
      })
    },
    goPlayerDetail(item) {
      this.pageJump(
        this.$router,
        `playerDetailIndex_${this.currThemeObj.moduleRouteNameEn}`,
        {
          cid: this.cid,
          sid: this.sid,
          tid: item.teamId,
          pid: item.playerId,
        }
      )
    },
    clickPublicTheme(themeItem) {
      // 分享主题
      let newThemeItem = themeItem
      console.debug('newThemeItem:', newThemeItem)
      if (!newThemeItem.analysisItemName) {
        // 有的主题有analysisItemName，有的没有，比如积分榜，因此处理一下，分享主题到公共播单的接口dataItemName都取这个字段
        newThemeItem.analysisItemName = newThemeItem.title
      }
      window.mixtmtBase_eventBus.$emit('publicThemeDialogEvent', {
        flag: true,
        themeItem: newThemeItem,
        mid: this.mid,
      })
    },
    MultipleChoiceSharingMenuRow_clickMenuHandler(item) {
      this.shareType = item.id
      this.MultipleChoiceSharingMenuRow_list.forEach((menuItem) => {
        if (item.id === menuItem.id) {
          menuItem.isAct = true
        } else {
          menuItem.isAct = false
        }
      })

      if (
        this.MultipleChoiceSharingMenuRow_list[1].id === 'score' &&
        this.MultipleChoiceSharingMenuRow_list[1].isAct
      ) {
        // 选中【评分】
        this.complexDoubleTeam_titleList[1] = this.subListThemeTitleArr[1]
        this.complexDoubleTeam_isScore = true
        // 展示替补阵容
        // let complexDoubleTeam_themeItem = JSON.parse(
        //   JSON.stringify(this.doubleTeamPlayerScore_themeItem)
        // )
        // if (this.curSelect_sectionType === this.matchInfor.homeId + '') {
        //   complexDoubleTeam_themeItem.renderData.objectInfo = [
        //     complexDoubleTeam_themeItem.renderData.objectInfo[0],
        //   ]
        //   complexDoubleTeam_themeItem.renderData.data.dataList = [
        //     complexDoubleTeam_themeItem.renderData.data.dataList[0],
        //     [],
        //   ]
        // } else if (this.curSelect_sectionType === this.matchInfor.awayId + '') {
        //   complexDoubleTeam_themeItem.renderData.objectInfo = [
        //     complexDoubleTeam_themeItem.renderData.objectInfo[1],
        //   ]
        //   complexDoubleTeam_themeItem.renderData.data.dataList = [
        //     [],
        //     complexDoubleTeam_themeItem.renderData.data.dataList[1],
        //   ]
        // }
        // this.complexDoubleTeam_themeItem = complexDoubleTeam_themeItem
      } else {
        // 其他情况
        this.complexDoubleTeam_titleList[1] = this.subListThemeTitleArr[0]
        this.complexDoubleTeam_isScore = false
        // 【首发阵容】 展示替补名单
      }
      this.formatComplexDoubleTeamHandler(
        this.curSelect_sectionType,
        this.shareType
      )
    },
    MultipleChoiceSharingMenuRow_clickPublicThemeHandler(item) {
      let themeItem = null
      // if (item && item.id === 'lineup') {
      //   themeItem = this.doubleTeamCombatLineup_themeItem
      // } else if (item && item.id === 'score') {
      //   themeItem = this.doubleTeamPlayerScore_themeItem
      // }
      themeItem = this.complexDoubleTeam_themeItem //在选择时已经将主题做了区分了
      if (themeItem) {
        this.clickPublicTheme(themeItem)
      } else {
        console.error('没有找到对应分享的主题数据：themeItem')
      }
    },
    computedComplexDoubleTeamThemeItemHandler(
      lineupDataList,
      subDataList,
      state
    ) {
      let complexDoubleTeam_dataList =
        lineupDataList &&
        lineupDataList.renderData &&
        lineupDataList.renderData.data &&
        lineupDataList.renderData.data.dataList
          ? JSON.parse(JSON.stringify(lineupDataList.renderData.data.dataList))
          : [[], []]
      const teamKeyList = ['home', 'away']
      teamKeyList.forEach((key, keyIndex) => {
        if (!state || (state && state === key)) {
          subDataList[keyIndex].forEach((subPlayerItem) => {
            complexDoubleTeam_dataList[keyIndex].push(subPlayerItem)
          })
        }
      })

      let complexDoubleTeam_themeItem = JSON.parse(
        JSON.stringify(lineupDataList)
      ) // 初始化时为替补名单
      complexDoubleTeam_themeItem.renderData.data.dataList =
        complexDoubleTeam_dataList
      return complexDoubleTeam_themeItem
    },
    async changeSelectToThemeItem(data) {
      const { analysisItemId, curSelectItem, filterTypes, actAllSelectObj } =
        data
      console.debug(
        '改变选择框',
        analysisItemId,
        curSelectItem,
        actAllSelectObj
      )
      // 接受 themeItem 组件传来事件，里面有每次切换选择框需要的参数
      // 1、当前选择框改变后，需要重置哪些选择框；
      // 2、找到哪些需要重置的选择框后，根据它自身里面的dep依赖和url来获取新的数据
      // 3、充值完所有新的数据后，要用新的选择框值来加载新的主题数据
      let clear = curSelectItem.clear
      let paramsArr = []
      if (clear.length > 0) {
        clear.forEach((clearItem) => {
          let paramsItem = null

          // 将依赖的值push到最后，访问的接口需要
          filterTypes.forEach((selectItem) => {
            if (selectItem.name == clearItem) {
              paramsItem = [
                analysisItemId,
                clearItem,
                selectItem.url,
                this.cid,
                this.sid,
                this.mid,
              ]
              if (selectItem.dep.length > 0) {
                selectItem.dep.forEach((depItem) => {
                  paramsItem.push(actAllSelectObj[depItem])
                })
              }
            }
          })

          paramsArr.push(paramsItem)
        })
      }
      if (paramsArr.length > 0) {
        for (let i = 0; i < paramsArr.length; i++) {
          const params = paramsArr[i]
          await this.getSelectApi(params)
        }
      }
      await this.getMoreDataByAnalysisID({
        analysisId: `[${analysisItemId}]`,
        json: `[${JSON.stringify(actAllSelectObj)}]`,
        competitionId: this.cid,
        seasonId: this.sid,
        matchId: this.mid,
      })
    },
    async getSelectApi(allParams) {
      // 切换主题上面的选择框，获取新的数据接口
      let analysisItemId = allParams[0]
      let selectName = allParams[1]
      let params = allParams.slice(2).join('/')
      console.debug(selectName, params)
      await https_package_selectApi(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.renderThemeList = this.renderThemeList.map((theme) => {
              if (theme.analysisItemId == analysisItemId) {
                let initSelectId = null
                theme.filter.filterTypes.forEach((selectItem) => {
                  if (selectItem.name == selectName) {
                    selectItem.values = res.data
                    initSelectId =
                      res.data && res.data[0].value ? res.data[0].value : ''
                  }
                })
                theme.actJson[selectName] = initSelectId
              }
              return theme
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async findAnalysisItem(templateType) {
      // 获取所有主题信息
      const params = {
        templateType,
        cid: this.cid,
        sid: this.sid,
        did: 0,
        eid: 0,
        pid: 0,
        mid: this.mid,
      }
      await https_package_findAnalysisItem(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            let themeAnalysisItemIdArr = []
            let jsonArr = []
            if (res.data && res.data.length > 0) {
              this.themeList = res.data.map((item) => {
                themeAnalysisItemIdArr.push(item.analysisItemId)
                jsonArr.push(item.json)
                let newItem = JSON.parse(JSON.stringify(item))
                newItem.actJson = JSON.parse(newItem.json)
                newItem.renderData = null
                if (newItem.analysisItemStyles) {
                  // 如果 analysisItemStyles 个数只有1个，则默认选第一个，如果有多个则不需要选默认的
                  let initAct =
                    newItem.analysisItemStyles.length === 1 ? true : false
                  newItem.analysisItemStyles.forEach(
                    (styleItem, styleIndex) => {
                      if (initAct && styleIndex === 0) {
                        styleItem.act = true
                      } else {
                        styleItem.act = false
                      }
                    }
                  )
                }
                newItem.title2RightName =
                  newItem.analysisItemStyles &&
                  newItem.analysisItemStyles.length
                    ? `${newItem.analysisItemStyles.length}种风格`
                    : ''
                return newItem
              })
              this.getMoreDataByAnalysisIDParams = {
                analysisId: `[${themeAnalysisItemIdArr.toString()}]`,
                json: `[${jsonArr.toString()}]`,
                competitionId: this.cid,
                seasonId: this.sid,
                matchId: this.mid,
              }
              this.getMoreDataByAnalysisID(this.getMoreDataByAnalysisIDParams)
              if (
                this.isRefresh &&
                this.refreshCallbackHandle &&
                !this.setIntervalId
              ) {
                this.refreshCallbackHandle(this.refreshCallback)
              }
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getMoreDataByAnalysisID(params) {
      // 根据获取的主题信息，去加载相应的主题数据，这一步完成才能渲染主题
      await https_package_getMoreDataByAnalysisID(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (this.renderThemeList) {
              let renderThemeList = this.renderThemeList
              res.data.forEach((newRenderData) => {
                renderThemeList.forEach((oldTheme) => {
                  if (oldTheme.analysisItemId == newRenderData.analysisItemId) {
                    oldTheme.renderData = newRenderData
                  }
                })
              })
              this.renderThemeList = renderThemeList
            } else {
              // 全部更换数
              this.renderThemeList = this.themeList.map((theme, index) => {
                theme.renderData = res.data[index]
                theme.matchId = this.mid
                theme.analysisItemName =
                  res.data[index] && res.data[index].title
                    ? res.data[index].title
                    : ''
                return theme
              })
            }
            // 双方首发阵容
            this.doubleTeamCombatLineup_themeItem = this.renderThemeList[1]

            // 组装双方替补名单数据
            let doubleTeamSubList_themeItem = JSON.parse(
              JSON.stringify(this.renderThemeList[7])
            )
            doubleTeamSubList_themeItem.title = '球队双方替补名单'
            doubleTeamSubList_themeItem.renderData.title =
              doubleTeamSubList_themeItem.title
            let homeSubList =
              this.renderThemeList[7].renderData &&
              this.renderThemeList[7].renderData.data &&
              this.renderThemeList[7].renderData.data.dataList
                ? this.renderThemeList[7].renderData.data.dataList[0].map(
                    (player) => {
                      player.formationPlace = null
                      return player
                    }
                  )
                : []
            let awaySubList =
              this.renderThemeList[8].renderData &&
              this.renderThemeList[8].renderData.data &&
              this.renderThemeList[8].renderData.data.dataList
                ? this.renderThemeList[8].renderData.data.dataList[0].map(
                    (player) => {
                      player.formationPlace = null
                      return player
                    }
                  )
                : []
            this.doubleTeamList_dataList = [homeSubList, awaySubList]
            doubleTeamSubList_themeItem.renderData.data.dataList =
              this.doubleTeamList_dataList
            this.doubleTeamSubList_themeItem = doubleTeamSubList_themeItem

            // 组装双方球队替补阵容(上过场的)
            let doubleTeamSubLineup_themeItem = JSON.parse(
              JSON.stringify(this.renderThemeList[4])
            )
            let doubleTeamSubLineupDataList_origin =
              this.renderThemeList[4].renderData &&
              this.renderThemeList[4].renderData.data &&
              this.renderThemeList[4].renderData.data.dataList
                ? this.renderThemeList[4].renderData.data.dataList
                : []
            let doubleTeamSubLineupDataList_new = []
            let doubleTeamScoreArr = [] //双方球队评分
            doubleTeamSubLineupDataList_origin.forEach((teamItem) => {
              let playerArr = []
              if (teamItem && teamItem.length > 0) {
                teamItem.forEach((playerItem) => {
                  if (playerItem.playerId === -1) {
                    doubleTeamScoreArr.push(playerItem)
                  } else if (
                    !playerItem.formationPlace &&
                    playerItem.playerId > 0 &&
                    !playerItem.x
                  ) {
                    // 替补阵容（换上的球员）
                    playerArr.push(playerItem)
                  }
                })
              }
              doubleTeamSubLineupDataList_new.push(playerArr)
            })
            console.debug(
              'doubleTeamSubLineup_themeItem:',
              doubleTeamSubLineup_themeItem
            )
            doubleTeamSubLineup_themeItem.renderData.data.dataList =
              doubleTeamSubLineupDataList_new
            this.doubleTeamSubLineup_themeItem = doubleTeamSubLineup_themeItem // 双方球队替补阵容

            //双方球员评分
            this.doubleTeamPlayerScore_themeItem = this.renderThemeList[4]

            // 主队阵容 横版
            this.singleTeam_homeLineup_themeItem = JSON.parse(
              JSON.stringify(this.renderThemeList[2])
            )
            this.singleTeam_homeLineup_themeItem.renderData.data.dataList = [
              this.singleTeam_homeLineup_themeItem.renderData.data.dataList[0],
              [],
            ]

            // 客队阵容 横版；
            this.singleTeam_awayLineup_themeItem = JSON.parse(
              JSON.stringify(this.renderThemeList[3])
            )
            // 单支球队需要区分主客队位置，所以这里【0】是主队，【1】是客队
            this.singleTeam_awayLineup_themeItem.renderData.data.dataList = [
              [],
              this.singleTeam_awayLineup_themeItem.renderData.data.dataList[0],
            ]

            if (!this.complexDoubleTeam_themeItem) {
              //初始化时 组装球员评分结构数据：首发阵容+替补名单
              this.complexDoubleTeam_isScore = false
              this.formatComplexDoubleTeamHandler('all', 'lineup')
            }
            this.commonThemeList = [this.renderThemeList[0]]
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#cup_scheduleDetail_lineup {
  padding: 1.68vw 0 4.166vw 0;
  .themeOperation_area {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 2.5vw;
    margin-bottom: 1.388vw;
    .themeType_changeArea {
      width: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      border: 1px solid var(--mixtmt_btn_tabMeun_actColor);
      border-radius: 1.25vw;
      .themeType_item {
        width: 8.62vw;
        line-height: calc(2.5vw - 2px);
        text-align: center;
        color: var(--mixtmt_btn_tabMeun_actColor);
        font-size: 0.972vw;
        &.act {
          background-color: var(--mixtmt_btn_tabMeun_actColor);
          color: var(--mixtmt_whiteColor);
          &:first-child {
            border-radius: 1.25vw 0 0 1.25vw;
          }
          &:last-child {
            border-radius: 0 1.25vw 1.25vw 0;
          }
        }
      }
    }
    .themeBtn_area {
      flex: 1;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
      span {
        display: inline-block;
        margin-left: 0.972vw;
        line-height: calc(2.5vw - 2px);
        font-size: 1.11vw;
        padding: 0 0.972vw;
        border: 1px solid var(--mixtmt_greyColor7);
        color: var(--mixtmt_greyColor2);
        border-radius: 2px;
        &:first-child {
          margin-left: 0;
        }
      }
    }
  }

  .commonThemeList {
    padding: 0 0 1.388vw 0;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    .themeItem_container {
      padding-bottom: 1.388vw;
      width: calc((100% - 1.389vw) / 2);
      &:nth-child(2n) {
        margin-left: 1.388vw;
      }
    }
  }
}

.mixtmt_pc #cup_scheduleDetail_lineup {
  .themeOperation_area {
    .themeType_changeArea {
      .themeType_item {
        cursor: pointer;
        &:hover {
          background-color: var(--mixtmt_btn_tabMeun_actColor);
          color: var(--mixtmt_whiteColor);
          &:first-child {
            border-radius: 1.25vw 0 0 1.25vw;
          }
          &:last-child {
            border-radius: 0 1.25vw 1.25vw 0;
          }
        }
      }
    }
    .themeBtn_area {
      span {
        cursor: pointer;
        &:hover {
          background-color: var(--mixtmt_btn_tabMeun_actColor);
          color: var(--mixtmt_whiteColor);
        }
      }
    }
  }
}
</style>
